import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const ThumbnailWrapper = styled.div<{ playerWidth: number }>`
	min-height: ${p => p.playerWidth}px;
	position: relative;
`;

export const MediaControls = styled.div`
	align-items: center;
	background: #f2f2f2;
	display: flex;
	justify-content: flex-start;
	height: 82px;
`;

export const TransportIcon = styled.svg`
	height: 30px;
	width: 30px;

	& path {
		fill: #0d0d0d;
	}

	&:hover {
		& path {
			fill: ${palette('schoolBlue')};
		}
	}
`;

export const TransportButton = styled.div`
	align-items: center;
	border-right: 1px #e4e4e4 solid;
	cursor: pointer;
	display: flex;
	height: 100%;
	padding: 0 24px;

	${minWidth('tablet')} {
		padding: 0 32px;
	}

	${minWidth('desktop')} {
		&:hover {
			& ${TransportIcon} path {
				fill: ${palette('schoolBlue')};
			}
		}
	}
`;

export const Metadata = styled.div`
	padding-left: 32px;
`;

export const Title = styled.h4`
	font-size: 20px;
	margin-bottom: 4px;
`;

export const Author = styled.div`
	font-size: 13px;
`;

export const AudioPlayer = styled.audio``;

export const AudioInfo = styled.div`
	display: flex;
	font-size: 14px;
	margin: 0 32px 0 auto;
`;

export const AudioPosition = styled.div`
	&:after {
		content: '/';
		margin-left: 4px;
	}
`;
export const AudioDuration = styled.div`
	margin-left: 4px;
`;

export const Wrapper = styled.div<{ isMultiple: boolean }>`
	margin-bottom: 12px;
	width: 100%;

	${p =>
		p.isMultiple &&
		`
    ${minWidth('tablet')} {
    width: calc(50% - 6px);
    }

    ${TransportIcon} {
      height: 20px;
      width: 20px;
    }

    ${TransportButton} {
      padding: 0 16px;
    }

    ${Title} {
      font-size: 16px;
    }

    ${Metadata} {
      padding-left: 16px;
    }

    ${AudioInfo} {
      margin-right: 16px;
    }
  `}
`;
